export default {
  getYears () {
    this.$http.get('/v1/dweller/accountability/years')
    .then(({data}) => {
      this.years = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/resources/methods.js